/* eslint-disable import/prefer-default-export */
import useSWR from "swr";
import {
  getUnusedSqlObjects,
  UnusedObjectsResponse,
} from "./unused-sql-objects-service";

export const useUnusedSqlObjects = () => {
  const { data, error, isLoading, mutate } = useSWR<UnusedObjectsResponse>(
    "/monitoring/sql/unused-objects",
    getUnusedSqlObjects,
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    },
  );

  const refresh = async () => {
    await mutate();
  };

  return {
    data,
    error,
    isLoading,
    refresh,
  };
};
